var map = {
	"./icon_menu_CL_Diagnosis1.png": "./src/assets/img/icon/icon_menu_CL_Diagnosis1.png",
	"./icon_menu_CombinationTherapy New.png": "./src/assets/img/icon/icon_menu_CombinationTherapy New.png",
	"./icon_menu_CombinationTherapy1.png": "./src/assets/img/icon/icon_menu_CombinationTherapy1.png",
	"./icon_menu_CombinationTherapy2.png": "./src/assets/img/icon/icon_menu_CombinationTherapy2.png",
	"./icon_menu_Default.png": "./src/assets/img/icon/icon_menu_Default.png",
	"./icon_menu_Diagnosis1.png": "./src/assets/img/icon/icon_menu_Diagnosis1.png",
	"./icon_menu_Diagnosis2.png": "./src/assets/img/icon/icon_menu_Diagnosis2.png",
	"./icon_menu_Dosage.png": "./src/assets/img/icon/icon_menu_Dosage.png",
	"./icon_menu_GIS.png": "./src/assets/img/icon/icon_menu_GIS.png",
	"./icon_menu_Generic.png": "./src/assets/img/icon/icon_menu_Generic.png",
	"./icon_menu_Handling.png": "./src/assets/img/icon/icon_menu_Handling.png",
	"./icon_menu_NonReimbursement.png": "./src/assets/img/icon/icon_menu_NonReimbursement.png",
	"./icon_menu_Pattern.png": "./src/assets/img/icon/icon_menu_Pattern.png",
	"./icon_menu_Pattern_ATC.png": "./src/assets/img/icon/icon_menu_Pattern_ATC.png",
	"./icon_menu_Pattern_Molecule.png": "./src/assets/img/icon/icon_menu_Pattern_Molecule.png",
	"./icon_menu_Pattern_Product.png": "./src/assets/img/icon/icon_menu_Pattern_Product.png",
	"./icon_menu_Sales.png": "./src/assets/img/icon/icon_menu_Sales.png",
	"./icon_menu_SoB.png": "./src/assets/img/icon/icon_menu_SoB.png",
	"./icon_menu_SoB2.png": "./src/assets/img/icon/icon_menu_SoB2.png",
	"./icon_menu_Switching.png": "./src/assets/img/icon/icon_menu_Switching.png",
	"./icon_menu_VaccineSales.png": "./src/assets/img/icon/icon_menu_VaccineSales.png",
	"./icon_menu_VaccineSalesOld.png": "./src/assets/img/icon/icon_menu_VaccineSalesOld.png",
	"./icon_menu_Weekly.png": "./src/assets/img/icon/icon_menu_Weekly.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/icon sync recursive ^\\.\\/icon_menu_.*\\.png$";